import { Component, inject, signal, effect, HostListener } from '@angular/core';
import {
  RouterOutlet,
  Router,
  NavigationEnd,
  ActivatedRoute,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { NavigationDrawerComponent } from './navigation-drawer/navigation-drawer.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { filter } from 'rxjs';
import { NavBarService } from './nav-bar.service';
import { CampaignBannerComponent } from '../campaign-banner/campaign-banner.component';
import { CustomToastComponent } from 'src/app/shared/components/custom-toast/custom-toast.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    NavigationDrawerComponent,
    CommonModule,
    ButtonModule,
    CampaignBannerComponent,
    CustomToastComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  private navBarService = inject(NavBarService);
  router = inject(Router);
  private route = inject(ActivatedRoute);

  showAgreementModal = signal(false);
  isNavDrawerOpen = this.navBarService.isNavDrawerOpen;

  constructor() {}

  get isHomePage(): boolean {
    return this.router.url === '/';
  }
}
